<template>
  <!-- 使用 visibility 而非 v-show，避免 display:none 导致容器尺寸为 0，BMapGL 初始化时中心点偏移 -->
  <div id="bdMap11" :style="{ visibility: isMapLoaded ? 'visible' : 'hidden' }"></div>
</template>

<script>
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
import riskLevel from '@/scripts/riskLevel.js'

/* ponytail: SVG marker — solid dot + semi-transparent halo.
   Colors from riskLevel.js, blended via opacity so they don't glare on dark bg. */
var _NORMAL_GREEN = '#33CC66'
function _mkIconSVG(riskCode) {
  var c = riskCode === 1 ? _NORMAL_GREEN : riskLevel.color(riskCode)
  var uri = 'data:image/svg+xml,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">' +
    '<circle cx="10" cy="10" r="9" fill="' + c + '" fill-opacity="0.2"/>' +
    '<circle cx="10" cy="10" r="4" fill="' + c + '"/>' +
    '</svg>'
  )
  return new BMapGL.Icon(uri, new BMapGL.Size(20, 20), {anchor: new BMapGL.Size(10, 10)})
}

var _iconCache = {}
function _getIcon(riskCode) {
  if (!_iconCache[riskCode]) _iconCache[riskCode] = _mkIconSVG(riskCode)
  return _iconCache[riskCode]
}
export default {
  data() {
    return {
      isMapLoaded: false,
      styleJson1:
        [
          {
        "featureType": "land",
        "elementType": "geometry",
        "stylers": {
          "color": "#113a57FF",
          "visibility": "on"
        }
      }, {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#335e7cFF",
          "visibility": "on"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#001066ff",
          "visibility": "on"
        }
      }, {
        "featureType": "building",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#00004dff",
          "visibility": "on"
        }
      }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": {
          "color": "#335e7cFF",
          "visibility": "on"
        }
      }, {
        "featureType": "village",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "town",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "district",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "country",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "poilabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#09304eFF",
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#09304eFF",
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "green",
        "elementType": "geometry",
        "stylers": {
          "color": "#104091ff",
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "geometry",
        "stylers": {
          "color": "#041c75ff",
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels.text.stroke",
        "stylers": {
          "weight": 1,
          "color": "#195fa8ff",
          "visibility": "on"
        }
      }, {
        "featureType": "continent",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "country",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "city",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "city",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "airportlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "transportationlabel",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "railway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "highwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "nationalwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "nationalwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "provincialwaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "provincialwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "tertiarywaysign",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "tertiarywaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subwaylabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "subwaylabel",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on",
          "weight": 90
        }
      }, {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "shopping",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "scenicspots",
        "elementType": "labels",
        "stylers": {
          "visibility": "on"
        }
      }, {
        "featureType": "scenicspotslabel",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "manmade",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "manmade",
        "elementType": "labels",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "highwaysign",
        "elementType": "labels.icon",
        "stylers": {
          "visibility": "off"
        }
      }, {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#10409100",
          "visibility": "on"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "road",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "road",
        "elementType": "labels.text",
        "stylers": {
          "fontsize": 24
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#1c4f7eff"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#1c4f7eff"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.fill",
        "stylers": {
          "color": "#154f9bff",
          "visibility": "on"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "geometry.stroke",
        "stylers": {
          "color": "#002c73ff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "local",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels.text.fill",
        "stylers": {
          "color": "#2a94ceff",
          "visibility": "on"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "labels.text.stroke",
        "stylers": {
          "color": "#195fa8ff",
          "visibility": "on",
          "weight": 1
        }
      }, {
        "featureType": "fourlevelway",
        "elementType": "geometry",
        "stylers": {
          "weight": 1
        }
      }, {
        "featureType": "tertiaryway",
        "elementType": "geometry",
        "stylers": {
          "weight": 1
        }
      }, {
        "featureType": "local",
        "elementType": "geometry",
        "stylers": {
          "weight": 1
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry",
        "stylers": {
          "weight": 3
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "highway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "highway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "highway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "nationalway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "provincialway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "8"
        }
      }, {
        "featureType": "provincialway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "9"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "8"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "9"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "8"
        }
      }, {
        "featureType": "provincialway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "8,10",
          "level": "9"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "6"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "7"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "8"
        }
      }, {
        "featureType": "cityhighway",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "6,9",
          "level": "9"
        }
      }, {
        "featureType": "arterial",
        "stylers": {
          "curZoomRegionId": "0",
          "curZoomRegion": "9,9",
          "level": "9"
        }
      }, {
        "featureType": "arterial",
        "elementType": "geometry",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "9,9",
          "level": "9"
        }
      }, {
        "featureType": "arterial",
        "elementType": "labels",
        "stylers": {
          "visibility": "off",
          "curZoomRegionId": "0",
          "curZoomRegion": "9,9",
          "level": "9"
        }
      }],
      BMapGL: null,
      map: null
    }
  },
  mounted() {
    this.BMapGL = window.BMapGL;
    this.initMap()
    this._changeIdHandler = (val) => { this.getmapcenter(val.deptId) }
    Bus.$on("changeid", this._changeIdHandler);
  },
  beforeDestroy() {
    if (this.map) {
          this.map.removeEventListener("tilesloaded", this._tilesLoadedHandler)
          this.map.removeEventListener("zoomend", this._zoomEndHandler)
          if (this._logViewport) this.map.removeEventListener("moveend", this._logViewport)
      this.map.destroy()
    }
    if (this._changeIdHandler) {
      Bus.$off("changeid", this._changeIdHandler)
    }
    if (this._zoomTimer) clearTimeout(this._zoomTimer)
  },
  methods: {
    getmapcenter(id){
      let that=this
      const param = {
        url: "/dept/center",
        method: "post",
        data: {
          deptId: id,
        },
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          var point = new BMapGL.Point(res.data.lng, res.data.lat);
          let zoom = 8
          if (res.data.districtLevel == 'country') zoom = 8
          else if (res.data.districtLevel == 'province') zoom = 10
          else if (res.data.districtLevel == 'city') zoom = 11
          else if (res.data.districtLevel == 'district') zoom = 15
          else if (res.data.districtLevel == 'street') zoom = 19
          that.map.setCenter(point);
          that.map.setZoom(zoom);
          that._logMapState("[getmapcenter]")
        }

      });
    },
    initMap () {
      this.map = new this.BMapGL.Map('bdMap11');
      this.map.enableScrollWheelZoom(true);
      this.map.setTilt(0);
      this.map.setMapStyleV2({styleJson: this.styleJson1});
      // 初始展示全国范围，getpointList 随后用 setViewport 自动适配视野
      this.map.centerAndZoom(new this.BMapGL.Point(116.4, 39.9), 5);
      this.getpointList()
      this._tilesLoadedHandler = () => { this.isMapLoaded = true }
      this.map.addEventListener("tilesloaded", this._tilesLoadedHandler);
      /* ponytail: fallback — if tiles never fire (adblock / slow net), show map anyway */
      setTimeout(() => { this.isMapLoaded = true }, 10000)
      this._zoomEndHandler = () => {
        var ZoomNum = this.map.getZoom();
        if (this._zoomTimer) clearTimeout(this._zoomTimer);
        this._zoomTimer = setTimeout(() => {
          this.map.clearOverlays();
          var grouped = this._groupOverlaps(this.staarr)
          for (let i = 0; i < grouped.length; i++) {
            ZoomNum < 13 ? this.setposition2(grouped[i]) : this.setposition(grouped[i])
          }
        }, 500)
      }
      this.map.addEventListener("zoomend", this._zoomEndHandler);
    },
    /* ponytail: SVG icons from riskLevel.js palette, cached */
    _pickIcon(riskLevel) {
      return _getIcon(riskLevel)
    },
    /* ponytail: label style — glass chip centered above dot marker.
       Fixed 200px width + textAlign:center + offset(-100,-44) puts label center at pt. */
    _makeLabel(text, pt) {
      var label = new BMapGL.Label(text, {
        position: pt,
        offset: new BMapGL.Size(-100, -44)
      })
      label.setStyle({
        color: '#FFFFFF',
        fontSize: '13px',
        fontFamily: '"AlibabaPuHuiTi-2-65-Medium","PingFang SC","Microsoft YaHei",sans-serif',
        fontWeight: '500',
        letterSpacing: '0.3px',
        textAlign: 'center',
        backgroundColor: 'rgba(10,22,40,0.20)',
        border: '1px solid rgba(42,98,255,0.0)',
        borderRadius: '8px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.08)',
        padding: '5px 0',
        lineHeight: '24px',
        whiteSpace: 'nowrap',
        width: '200px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      })
      return label
    },
    /* ponytail: group staarr by lng+lat so overlapping points get a single marker
       showing count. Click emits all deptIds/deptNames for the popup list. */
    _groupOverlaps(list) {
      if(!list) return []
      var groups = {}
      list.forEach(function(s){
        if(!s.lat || !s.lng) return
        /* ponytail: coerce to Number — API may return strings */
        var lng = +s.lng, lat = +s.lat
        if(isNaN(lng) || isNaN(lat)) return
        var key = lng.toFixed(5) + ',' + lat.toFixed(5)
        if(!groups[key]) groups[key] = []
        groups[key].push(s)
      })
      return Object.keys(groups).map(function(key){
        var items = groups[key]
        var first = items[0]
        return {
          lng: first.lng,
          lat: first.lat,
          deptId: first.deptId,
          deptName: items.length === 1 ? first.deptName : first.deptName + ' 等' + items.length + '家',
          _count: items.length,
          _items: items,
          mostSeriousRiskLevel: first.mostSeriousRiskLevel
        }
      })
    },
    /* ponytail: click handler — find nearby points within ~25m, sorted by riskLevel desc */
    _onPointClick(sta, e) {
      var threshold = 0.00025 // ≈ 25m
      /* ponytail: coerce to Number — API may return strings */
      var stalng = +sta.lng, stalat = +sta.lat
      var nearby = this.staarr.filter(function(s){
        return s.lat && s.lng &&
          Math.abs(+s.lat - stalat) < threshold &&
          Math.abs(+s.lng - stalng) < threshold
      })
      // deduplicate by deptId, sort by mostSeriousRiskLevel desc (highest risk first)
      var seen = {}
      var items = nearby.filter(function(s){
        if(seen[s.deptId]) return false
        seen[s.deptId] = true
        return true
      }).sort(function(a, b){
        return (b.mostSeriousRiskLevel || 0) - (a.mostSeriousRiskLevel || 0)
      })
      Bus.$emit('mapPointClick', {
        deptId: items[0].deptId,
        deptName: items[0].deptName,
        _items: items
      })
    },
    setposition(sta) {
      if(sta.mostSeriousRiskLevel === 0 || !sta.lat || !sta.lng) return
      var src = this._pickIcon(sta.mostSeriousRiskLevel)
      if(sta.lat && sta.lng) {
        var pt = new BMapGL.Point(sta.lng, sta.lat)
        var marker = new BMapGL.Marker(pt, { icon: src })
        this.map.addOverlay(marker)
        var labelText = sta._count > 1 ? sta.deptName : sta.deptName
        var label = this._makeLabel(labelText, pt)
        this.map.addOverlay(label)
        var _this = this
        marker.addEventListener('click', function (e) {
          _this._onPointClick(sta, e)
        })
      }
    },
    setposition2(sta) {
      if(sta.mostSeriousRiskLevel === 0 || !sta.lat || !sta.lng) return
      var src = this._pickIcon(sta.mostSeriousRiskLevel)
      if(sta.lat && sta.lng) {
        var pt = new BMapGL.Point(sta.lng, sta.lat)
        var marker = new BMapGL.Marker(pt, { icon: src })
        this.map.addOverlay(marker)
        var _this = this
        marker.addEventListener('click', function (e) {
          _this._onPointClick(sta, e)
        })
      }
    },
    getpointList(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/bigScreen/regionalPosition";
      param.data={

      }
      Axios.ajax(param).then((res)=>{
        if(res.data){
          this.staarr=res.data
          var initPoints = that._groupOverlaps(res.data)
          for(let i=0;i<initPoints.length;i++){
            that.setposition2(initPoints[i])
          }
          // 用 BaiduMap setViewport 自动适配视野到所有企业点位
          const validPoints = res.data.filter(p => p.lat && p.lng).map(function(p){
            return { lng: +p.lng, lat: +p.lat }
          })
          if (validPoints.length > 0) {
            const points = validPoints.map(p => new that.BMapGL.Point(p.lng, p.lat))
            that.map.setViewport(points, {
              margins: [30, 30, 30, 30]
            })
            /* ponytail: log final viewport after BaiduMap finishes animating */
            that.map.addEventListener("moveend", that._logViewport = function() {
              that._logMapState("[regionalPosition]")
              that.map.removeEventListener("moveend", that._logViewport)
              that._logViewport = null
            })
          } else {
            // 无企业点位，回退到用户组织中心
            that.fallbackToUserCenter()
          }
        }
      })
    },
    fallbackToUserCenter() {
      Axios.ajax({ url: "/dept/userCenter", method: "post", data: {} }).then((res) => {
        if (res.data) {
          var pt = new this.BMapGL.Point(res.data.lng, res.data.lat);
          this.map.centerAndZoom(pt, 8);
          this._logMapState("[fallback userCenter]")
        }
      });
    },
    /* ponytail: diagnostics — log current map center + zoom to console */
    _logMapState(tag) {
      if (!this.map) return
      var c = this.map.getCenter()
      console.log(tag, "lng:", c.lng, "lat:", c.lat, "zoom:", this.map.getZoom())
    },
    },
  }
</script>

<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 100%;
  position: relative;
}

#bdMap11 {
  width: 100%;
  height: 100%;
  position: fixed !important;
  z-index: 0;
}
</style>
